import React, {useState} from 'react'

import './Popup.scss'

const Popup = props => {

	// props:
	// data, see below
	// scrim:false turns scrim off. can also be in data
	// centered:false turns off auto centering of popup-container
	// style is style json that gets applied to popup-container
	// instant:true turns off cleanup phase and intro animations


	const [cleanup, setCleanup] = useState(false)

	const data = props.data || {
		scrim:true,
		header:'Error',
		body:"Popup data prop not provided",
		button:"button"
	}

	const handleButtonClick = () => {
		setCleanup(true);
		setTimeout(()=> {
			if(props.onClose) props.onClose();
			if(props.onComplete) props.onComplete();
		}, (props.instant === true ? 0 : 600))
	
	}

	const getAnimationClasses = () => {
		if(props.instant === true) return '';
		return cleanup ? 'cleanup' : 'not-cleanup'
	}

	return (
		<div className={`Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
			{
				(data.scrim || props.scrim) && 
				<div className="scrim" style={props.style || {}}></div>
			}
			<div className="popup-container" style={props.style || {}}>
				<div className="popup-container-header" dangerouslySetInnerHTML={{__html:data.header}}></div>
				<div className="popup-container-body" dangerouslySetInnerHTML={{__html:data.body}}></div>
				<div className="button global-button" 
					dangerouslySetInnerHTML={{__html:data.button}}
					onClick={handleButtonClick}
					></div>
			</div>
		</div>
	)
}

export default Popup;
